import React, {useState} from 'react'


export default function Contact ()  {
  
  
    const [selectedValue, setSelectedValue] = useState('option1');

        const handleChange = (event) => {
            setSelectedValue(event.tagert.value);
        }

  return (
    <section>
        <div className='container'>
            <h3 className='text-center form-heading'>
                Make it Unique!
                <div className='custom-des'>Please give us details about what you would like customized. <small>We will reach out for futher details</small></div>
                <form className='form-control' id='form-control' action=''>

                    <h2>Custom Contact Form</h2>
                    <label htmlFor='firstName'>
                    <input type='text' placeholder='Full Name' id='firstName' name='user_name' required />
                    </label>
                    <label htmlFor='emailUser' >

                    <input type='email' placeholder='Email'name='user_email' required id='emailUser'   />
                    </label>
                    <label or='text-input'>
                    <input type='text' placeholder='Subject' name='subject' required  id='text-input' />
                    </label>
                    

                    <textarea name='message' cols={10} rows={30} />

                    <select value={selectedValue} onChange={handleChange} className="form-select" aria-label="select main" id='form-select'>
                        <option className='selectTile' >What type of piece would you like customized?</option>
                        <option value="option1">Jewerly</option>
                        <option value="option2">Art</option>
                        <option value="option3">Clothing</option>
                        <option value="option4">Figure/Stuffy or something else</option>
                        </select>
                        Please describe in detail what you would like on the custom piece.
                        <div className='example'>Please include: One main color, size, medium or any other specifics. We will reach out to confirm and get more details if needed 😊  </div>
                    
                    <button className='send-btn' type='submit'>Send Message</button>
                </form>
            </h3>


        </div>
      



    </section>
  )
}



